<template>
  <div class="peopleSearch">
    <div class="people-search-header">
      <el-form :inline="true">
        <el-form-item label="姓名">
          <el-autocomplete
            v-model="tableParams.name"
            :fetch-suggestions="searchAsync"
            :trigger-on-focus="false"
            @select="handleSelect"
            placeholder=""
            clearable
          >
          </el-autocomplete>
          <!-- <el-input  placeholder="姓名" v-model="tableParams.name"></el-input> -->
        </el-form-item>
        <el-form-item label="证件号码">
          <el-input
            placeholder="证件号码"
            v-model="tableParams.cardNumber"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="查询时间">
          <h-date-timerange
            v-model:end="tableParams.endTime"
            v-model:start="tableParams.beginTime"
            :clearable="false"
          >
          </h-date-timerange>
        </el-form-item>
        <el-form-item label="分析组织">
          <h-button @click="equipmentClick">{{
            currentEquipment.length > 0
              ? `已选择${currentEquipment.length}台设备`
              : "全部设备"
          }}</h-button>
        </el-form-item>
        <el-form-item>
          <el-popover width="177px">
            <template #reference>
              <h-icon icon="icon-zhuapaixiangji" font-size="26"></h-icon>
            </template>
            <upload-picture
              ref="uploadPictureRef"
              v-model:file="personImageUrl"
              @showPicture="handleUploadPicture"
            ></upload-picture>
          </el-popover>
          <img src="" alt="" />
        </el-form-item>
        <el-form-item>
          <h-button type="primary" @click="refreshTable">查询</h-button>
          <!-- <h-button>导出</h-button> -->
        </el-form-item>
      </el-form>
      <div class="container" v-loading="loading">
        <el-empty class="h-card-empty" v-if="dataList.length == 0"></el-empty>
        <div class="centerBox" v-else>
          <div
            class="centerList"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <div class="centerImg" @click="detailClick(item)">
              <img v-if="item.imagePartUrl" :src="item.imagePartUrl" />
              <img v-else src="~@/assets/images/moren.png" />
            </div>
            <div class="centerTitle">
              <span>{{ item.deviceName }}</span>
              <span>
                <span>{{
                  moment(parseInt(item.snapTime)).format("YYYY-MM-DD HH:mm:ss")
                }}</span></span
              >
            </div>
          </div>
        </div>
        <div class="pagination">
          <!-- 分页 -->
          <el-pagination
            v-model:currentPage="currentPage1"
            :page-size="[20, 50, 100, 200]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationTotal"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
      <transfer-application
        v-model:visible="transferVisible"
        v-show="transferVisible"
        @transferApplicationList="getTransferList"
      ></transfer-application>
      <personDetailDialog
        v-if="personDetailVisible"
        v-model:visible="personDetailVisible"
        :itemInfo="personDetailItem"
      ></personDetailDialog>
      <h-big-picture
        :pictureUrl="pictureUrl"
        v-model:visible="bigPictureVisible"
      ></h-big-picture>
    </div>
  </div>
</template>

<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";

import { queryUserList } from "@/api/realPopulation/realPopulation";
import { formatDateHMSSJC, formatDateHMS } from "@/utils/index.js";
import {
  url2ToBase,
  facemanymany,
} from "@/api/smartApplication/personSearchApi.js";

import _ from "lodash";
import moment from "moment";
import util from "@util/js";
import HBigPicture from "../../components/global/HBigPicture.vue";

export default defineComponent({
  name: "peopleSearch",
  components: { HBigPicture },
  props: {},
  setup(props) {
    const state = reactive({
      imgURL: window.imgURL,
      loading: false,
      input: "",
      value: "",
      currentPage: 1,
      pageSize: 100,
      small: false,
      background: false,
      disabled: false,
      dataList: [],
      paginationTotal: 0,
      tableParams: {
        name: "",
        cardNumber: "",
        deviceIds: [],
        imageDataList: [],
        endTime: formatDateHMS(new Date()),
        beginTime: formatDateHMS(new Date().getTime() - 24 * 3600 * 1000 * 7),
        topK: 20,
        threshold: 60,
      },
      personImageUrl: "",
      bigPictureVisible: false,
      pictureUrl: "",
      transferVisible: false,
      currentEquipment: [],
      personDetailVisible: false,
      personDetailItem: {},
    });
    const flag = ref(false);
    const uploadPictureRef = ref();
    const options = [
      {
        value: "Option1",
        label: "Option1",
      },
      {
        value: "Option2",
        label: "Option2",
      },
      {
        value: "Option3",
        label: "Option3",
      },
      {
        value: "Option4",
        label: "Option4",
      },
      {
        value: "Option5",
        label: "Option5",
      },
    ];
    // 获取结构树
    const searchAsync = async (queyString, cb) => {
      if (!state.tableParams.name) return;
      state.personImageUrl = "";
      state.tableParams.cardNumber = "";
      const form = {
        name: state.tableParams.name,
        regionId: 1,
        isPage: false,
      };
      clearTimeout(data.timeOut);

      state.timeOut = setTimeout(async () => {
        const res = await queryUserList(form);
        if (res.code == 0) {
          res.page.list.forEach((element) => {
            element.value = element.name + "  " + element.cardNumber;
          });
          cb(res.page.list);
        }
      }, 1000);
    };
    // 点击结构树
    const handleSelect = async (item) => {
      state.tableParams.name = item.name;
      state.tableParams.cardNumber = item.cardNumber;
      console.log(!item.imageUrl);
      if (!item.imageUrl) {
        ElMessage.warning("实有人口库中该对象无照片。请先更新照片");
      } else {
        console.log(item.imageUrl);
        state.personImageUrl = state.imgURL + item.imageUrl;
      }
    };
    // 获取穿梭框数据
    const getTransferList = (val) => {
      state.transferVisible = false;
      state.tableParams.deviceIds = [];
      console.log(val);
      val.forEach((element) => {
        state.tableParams.deviceIds.push(element.deviceId);
      });
      console.log(state.tableParams.deviceIds);
      state.currentEquipment = val;
    };
    // 卡扣选择弹窗
    const equipmentClick = () => {
      state.transferVisible = true;
    };
    // 详情弹窗
    const detailClick = (item) => {
      state.personDetailItem = item.list.length > 0 && item.list[0];
      state.personDetailItem.similarity = item.similarity;
      state.personDetailVisible = true;
    };
    const handleCurrentChange = (val) => {
      state.tableParams.pageSize = val;
      facemanymanyAxios();
    };
    const upload = () => {
      flag.value = !flag.value;
      console.log(flag.value);
    };
    const facemanymanyAxios = async () => {
      state.loading = true;
      const form = _.cloneDeep(state.tableParams);
      const list = await facemanymany(form);
      state.dataList = list.page.list;
      state.paginationTotal = list.page.totalCount;
      state.loading = false;
    };
    const refreshTable = async () => {
      if (!uploadPictureRef.value.base64File[0] && !state.personImageUrl) {
        ElMessage.warning("请添加照片");
        return;
      }

      if (state.personImageUrl) {
        util.urlGetBase64(state.personImageUrl, (data) => {
          state.tableParams.imageDataList = [];
          state.tableParams.imageDataList.push({
            data: data,
            fileName: "1",
          });
          facemanymanyAxios();
        });
      } else {
        state.tableParams.imageDataList = [];
        state.tableParams.imageDataList.push({
          data: uploadPictureRef.value.base64File[0],
          fileName: "1",
        });
        facemanymanyAxios();
      }
    };
    // 查看大图
    const handleUploadPicture = (val) => {
      state.pictureUrl = val;
      state.bigPictureVisible = true;
    };
    return {
      ...toRefs(state),
      uploadPictureRef,
      formatDateHMSSJC,
      options,
      flag,
      refreshTable,
      handleCurrentChange,
      upload,
      handleUploadPicture,
      detailClick,
      searchAsync,
      handleSelect,
      moment,
      equipmentClick,
      getTransferList,
    };
  },
});
</script>
<style lang="scss" scoped>
.peopleSearch {
  height: 100%;
  width: 100%;
  .people-search-header {
    padding: 25px 15px 0 15px;
    height: 100%;
  }
  .container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 90px);
    margin-top: 15px;
  }
  .pagination {
    margin-top: 12px;
  }
  .centerBox {
    width: 100%;
    height: 100%;
    flex: 1;
    display: grid;
    grid-template-columns: repeat(auto-fill, 316px);
    grid-template-rows: repeat(auto-fill, 214px);
    grid-gap: 11px 24px;
    justify-content: space-around;
    overflow: auto;

    .centerList {
      width: 300px;
      height: 210px;
      border-radius: 10px;
      margin: 10px;
      padding: 16px;
      box-shadow: 0 5px 15px 0 #b1abab;
      cursor: pointer;
      .centerTitle {
        height: 60px;
        text-align: center;
        @include flex-col-c-s;
        span {
          height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .centerImg {
        height: 70%;

        img {
          width: 100%;
          height: 100%;
          border-radius: 4px 4px 0 0;
        }
      }
    }
  }
  .box-card {
    height: calc(100% - 85px);
    .box-card-content {
      margin-top: 8px;
      height: 70%;
      overflow: auto;

      .el-row {
        .el-col {
          margin-top: 15px;
          margin-left: 35px;
          flex: none;
          .el-card {
            padding: 10px;
            width: 270px;
            height: 250px !important;
            overflow: hidden !important;
            .text {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              span {
                margin-top: 15px;
              }
            }
          }
        }
      }
      .image {
        width: 100%;
        display: block;
      }
    }
    .pager {
      position: absolute;
      right: 80px;
      bottom: 50px;
    }
  }
}
.el-popover {
  width: 500px;
  height: 300px;
}
</style>